module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1600 1600\"><path d=\"M1088 1248v192q0 40-28 68t-68 28H800q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28H800q-40 0-68-28t-28-68V736q0-40 28-68t68-28h192q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28H800q-40 0-68-28t-28-68V224q0-40 28-68t68-28h192q40 0 68 28t28 68z\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_ellipsis_v.svg
// module id = ../../views/shared/icons/_ellipsis_v.svg
// module chunks = pages.projects.issues.show pages.projects.merge_requests.show